var map = {
	"./Dermaslim wellness clinic Interiors_page-0002.webp": 7312,
	"./Dermaslim wellness clinic Interiors_page-0003.webp": 9523,
	"./Dermaslim wellness clinic Interiors_page-0004.webp": 5134,
	"./Dermaslim wellness clinic Interiors_page-0006.webp": 4140,
	"./Dermaslim wellness clinic Interiors_page-0008.webp": 602,
	"./Dermaslim wellness clinic Interiors_page-0009.webp": 1701,
	"./Dermaslim wellness clinic Interiors_page-0010.webp": 6055,
	"./Dermaslim wellness clinic Interiors_page-0011.webp": 2356,
	"./Dermaslim wellness clinic Interiors_page-0012.webp": 6641,
	"./Dermaslim wellness clinic Interiors_page-0013.webp": 1798,
	"./Dermaslim wellness clinic Interiors_page-0014.webp": 9563,
	"./Dermaslim wellness clinic Interiors_page-0015.webp": 9656,
	"./Dermaslim wellness clinic Interiors_page-0016.webp": 2085,
	"./Dermaslim wellness clinic Interiors_page-0017.webp": 6570,
	"./Dermaslim wellness clinic Interiors_page-0018.webp": 6383,
	"./Dermaslim wellness clinic Interiors_page-0019.webp": 6140,
	"./Dermaslim wellness clinic Interiors_page-0020.webp": 6220,
	"./Dermaslim wellness clinic Interiors_page-0021.webp": 7807,
	"./Dermaslim wellness clinic Interiors_page-0022.webp": 4462,
	"./Dermaslim wellness clinic Interiors_page-0023.webp": 4185,
	"./Dermaslim wellness clinic Interiors_page-0024.webp": 3760,
	"./Dermaslim wellness clinic Interiors_page-0025.webp": 4195,
	"./Dermaslim wellness clinic Interiors_page-0026.webp": 2498,
	"./Dermaslim wellness clinic Interiors_page-0027.webp": 2413,
	"./Dermaslim wellness clinic Interiors_page-0028.webp": 7940,
	"./Dermaslim wellness clinic Interiors_page-0029.webp": 2647,
	"./Dermaslim wellness clinic Interiors_page-0030.webp": 8409,
	"./Dermaslim wellness clinic Interiors_page-0031.webp": 3726,
	"./Dermaslim wellness clinic Interiors_page-0032.webp": 6975,
	"./Dermaslim wellness clinic Interiors_page-0033.webp": 8732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6914;